export default {
	/**
	 * Save data from TheFormMessage
	 */
	formMessage: (state, data) => {
		state.form.to = data;
	},

	/**
	 * Save the selected gift
	 */
	formGift: (state, gift) => {
		state.form.gift = gift;
	},

	/**
	 * Save the donation & payment information
	 */
	formPayment: (state, {from, donation, payment}) => {
		state.form.from = from;
		state.form.donation = Number(donation);
		state.form.payment = payment;
	},

	totalEntries: (state, entries) => {
		state.entries = entries;
	},

	bouncingArrow: (state, status) => {
		state.bouncingArrow = status;
	},
};



// WEBPACK FOOTER //
// ./src/store/mutations.js